import { onAttrChangeInElement } from '../../../../utils/dom/on-attr-change-in-element';
import { onElementInDom } from '../../../../utils/dom/on-element-in-dom';

export const onContainerChanges = (
  selector: string,
  cb: (element: HTMLElement, sku?: string, imageSrc?: string) => void
) => {
  const observerOptions: MutationObserverInit = {
    attributeFilter: [ 'data-sku', 'data-syte-sku', 'data-image-src', 'data-collection-id' ],
    attributeOldValue: true,
  };
  let unobserveAttributes: () => void;

  onElementInDom(selector, el => {
    const {
      sku,
      imageSrc,
      syteSku,
    } = (el as HTMLElement).dataset;
    cb(el as HTMLElement, sku || syteSku, imageSrc);
    if (unobserveAttributes) {
      unobserveAttributes();
    }
    unobserveAttributes = onAttrChangeInElement(el as HTMLElement, observerOptions, element => {
      const { dataset } = element;
      cb(element, dataset.sku || dataset.syteSku, dataset.imageSrc);
    });
  });
  // TODO: maybe return a 'unobserve' func from onElementInDom if init get called multiple times
};
